import React, { useState, useCallback } from 'react';
import WorkflowDemo from './WorkflowDemo';
import TestRuns from './TestRuns';
import AnalysisPipeline from './AnalysisPipeline';
import './DemoShowcase.css';

const DemoShowcase = () => {
  const [activeTab, setActiveTab] = useState('workflow');
  const [mountKey, setMountKey] = useState(0);

  const switchTab = useCallback((tab) => {
    setActiveTab(tab);
    setMountKey(k => k + 1);
  }, []);

  return (
    <div className="demo-showcase">
      <div className="demo-toggle-bar">
        <div className="demo-toggle">
          <button
            className={`demo-toggle-btn ${activeTab === 'workflow' ? 'demo-toggle-active' : ''}`}
            onClick={() => switchTab('workflow')}
          >
            Workflow
          </button>
          <button
            className={`demo-toggle-btn ${activeTab === 'test-runs' ? 'demo-toggle-active' : ''}`}
            onClick={() => switchTab('test-runs')}
          >
            Test Runs
          </button>
          {/* Analysis tab hidden — keep code so it's a 1-line uncomment to
              bring back. AnalysisPipeline component still imported + still
              renders if activeTab is set externally. */}
          {false && (
            <button
              className={`demo-toggle-btn ${activeTab === 'analysis' ? 'demo-toggle-active' : ''}`}
              onClick={() => switchTab('analysis')}
            >
              Analysis
            </button>
          )}
        </div>
      </div>
      <div className="demo-content">
        {activeTab === 'workflow' && <WorkflowDemo key={`wf-${mountKey}`} />}
        {activeTab === 'test-runs' && <TestRuns key={`tr-${mountKey}`} />}
        {activeTab === 'analysis' && <AnalysisPipeline key={`ap-${mountKey}`} />}
      </div>
    </div>
  );
};

export default DemoShowcase;
